export const profile = {
  name: "Kevin Hernandez-Nino",
  email: "klhn2312@gmail.com",
  resume: "/resume/kevin-hernandez-nino-resume.pdf",
  linkedin: "https://www.linkedin.com/in/kevinlhn/",
  github: "https://github.com/kevinlhn",
};
// Titles, dates, education and responsibilities are transcribed/summarized from
// the original portfolio's linked résumé. The PDF is preserved unchanged.
export const experience = [
  {
    company: "Hanford Mission Integration Solutions",
    role: "Computer Engineer",
    date: "Joined 2023",
    location: "Richland, WA",
    category: "SYSTEMS & INTEGRATION",
    description:
      "Design, implementation, and maintenance of complex security systems. Technical plans, engineering documentation, installation, testing, and coordination across disciplines.",
    responsibilities: [
      "Integrated security systems",
      "Installation & verification",
      "Technical documentation",
      "Cross-disciplinary delivery",
    ],
  },
  {
    company: "Pacific Computer Technologies",
    role: "Software Engineer Intern",
    date: "2022–2023",
    location: "Remote",
    category: "SOFTWARE & INTERFACES",
    description:
      "Contributed to a housing management system, building responsive React components, testing and debugging behavior, and documenting architecture with senior engineers.",
    responsibilities: [
      "React front-end development",
      "UI accessibility",
      "Testing & debugging",
      "Architecture documentation",
    ],
  },
  {
    company: "Walla Walla University",
    role: "Resident Dean",
    date: "2019–2023",
    location: "College Place, WA",
    category: "PEOPLE & RESPONSIBILITY",
    description:
      "Managed a residential community, led a team of resident assistants, and coordinated with university staff and faculty to support students.",
    responsibilities: [
      "Team leadership",
      "Community operations",
      "Coordination & communication",
      "Problem solving",
    ],
  },
];
